import * as React from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  ButtonBack,
  ContainerProcedure
} from '../../ChangeCareerCampusModality/info/components';
import { SubContainer } from '../../../certificates-constancies/type1/info/components';
import { ProcedureInfoComponent } from './components/ProcedureInfoComponent';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';
import routes from '@/presentation/components/Routes/routingMap';
import useProfile from '@/presentation/hooks/useProfile';
import Spinner from '@/presentation/components/Spinner';
import { Creators as procedureActions } from '@/domain/useCases/procedures/getProcedureInformation';
import ShowModalError from '@/presentation/modules/procedures/components/Errors';
import useModals from '@/presentation/hooks/useModals';
import ReusableButton from '@/presentation/reusables/Button';
import StepsToFollow from '@/presentation/modules/procedures/components/StepsToFollow';
import WhiteContainer from '@/presentation/modules/procedures/components/ContainerProcedure/WhiteContainer';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const EmployabilityCharterView = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { academic } = useProfile();
  const { procedure: procedureSelectedInfo, isLoading } = useSelector(
    (state: any) => state.procedureInformation
  );
  const defaultModals = {
    notAvailableModal: false,
    alreadyExistsModal: false,
    validationModal: false
  };
  const customActions = {
    notAvailableModal: () => {},
    alreadyExistsModal: () => {},
    validationModal: () => {}
  };
  const { modals, openModal, closeModal, actionModal } = useModals(
    defaultModals,
    customActions
  );

  const getProcedurenfo = (studentType: 'EGRE' | '') => {
    if (!procedureSelectedInfo && !isLoading)
      dispatch(procedureActions.getProcedureInformation(1038, studentType));
  };

  React.useEffect(() => {
    GoogleAnalytics.writeLog('portal-procedure-employabilityCharter', 'portal');
  }, []);

  React.useEffect(() => {
    if (academic) {
      const { isGraduated } = academic;
      getProcedurenfo(isGraduated ? 'EGRE' : '');
    }
  }, [academic]);

  const startRequestHandler = () => {
    // procedure is disabled
    if (procedureSelectedInfo.disabled) {
      openModal('notAvailableModal');
      return;
    }
    // procedure already exists
    if (procedureSelectedInfo.currentRequestId > 0) {
      openModal('alreadyExistsModal');
      return;
    }
    // procedure has an error
    if (procedureSelectedInfo.error) {
      openModal('validationModal');
      return;
    }

    history.push(
      routes.student.procedures.categories.requests.employabilityCharter
        .register
    );
  };

  const handlerBackButton = () => {
    history.goBack();
  };

  return (
    <div data-testid="cmp-employabilityCharterView">
      <ContainerProcedure>
        <SubContainer>
          <ButtonBack onClick={handlerBackButton} />
          <ProcedureHeader name="Carta de presentación para prácticas, empleo o internado" />
        </SubContainer>
        {academic && procedureSelectedInfo ? (
          <SubContainer>
            <ProcedureHeader
              amount={procedureSelectedInfo.amount}
              duration={procedureSelectedInfo.duration}
              paddingData={12}
              paddingBottomData={8}
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 12,
                marginTop: 10
              }}
            >
              <WhiteContainer>
                <ProcedureInfoComponent pin1={procedureSelectedInfo.pin1} />
              </WhiteContainer>
              <WhiteContainer className="shadow">
                <div style={{ margin: '8px 0px' }}>
                  <StepsToFollow steps={procedureSelectedInfo.stepsToFollow} />
                </div>
              </WhiteContainer>
              <div style={{ marginTop: 28 }}>
                <ReusableButton
                  text="Empezar solicitud"
                  onClick={startRequestHandler}
                />
              </div>
            </div>

            <ShowModalError
              modals={modals}
              closeModal={closeModal}
              actionModal={actionModal}
              error={procedureSelectedInfo.error}
            />
          </SubContainer>
        ) : (
          <Spinner />
        )}
      </ContainerProcedure>
    </div>
  );
};

export default EmployabilityCharterView;
